import React, { useState } from 'react';
import { Button } from 'primereact/button';
import UserMealCard from './UserMealCard';

const UserRecipes = ({ userMeals, onCreateClick, onViewRecipe, onDeleteRecipe }) => {
    const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'

    return (
        <div className="my-recipes-panel">
            <div className="recipes-hero">
                <h2>Your Culinary Collection</h2>
                <p>Store and organize your favorite personal recipes</p>

                <Button
                    label="New"
                    icon="pi pi-plus"
                    className="create-recipe-btn"
                    style={{ gap: '0.5rem' }}   
                    onClick={onCreateClick}
                />
            </div>

            <div className="recipes-content">
                <>
                    <div className="collection-header">
                        <h3>Your Personal Recipes ({userMeals.length})</h3>
                        <div className="view-options">
                            <Button
                                icon="pi pi-th-large"
                                className={`p-button-text ${viewMode === 'grid' ? 'p-button-secondary' : ''}`}
                                onClick={() => setViewMode('grid')}
                            />
                            <Button
                                icon="pi pi-list"
                                className={`p-button-text ${viewMode === 'list' ? 'p-button-secondary' : ''}`}
                                onClick={() => setViewMode('list')}
                            />
                        </div>
                    </div>

                    {viewMode === 'grid' ? (
                        <div className="recipes-grid">
                            {userMeals.map(meal => (
                                <div className="recipe-item" key={meal.id}>
                                    <UserMealCard
                                        meal={meal}
                                        onView={onViewRecipe}
                                        onDelete={onDeleteRecipe}
                                    />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="recipes-list">
                            {userMeals.map((meal) => (
                                <div className="recipe-list-item" key={meal.id} onClick={() => onViewRecipe(meal)}>
                                    <div className="recipe-list-details">
                                        <h4>{meal.title}</h4>
                                        <p>Type: {meal.mealType}</p>
                                        <p>Prep Time: {meal.prepTime} minutes</p>
                                        <p>Servings: {meal.servings}</p>
                                    </div>
                                    <div className="recipe-list-actions">
                                        <Button
                                            icon="pi pi-trash"
                                            className="p-button-text p-button-danger"
                                            onClick={() => onDeleteRecipe(meal)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </>
            </div>
        </div>
    );
};

export default UserRecipes;